import { createGlobalStyle } from 'styled-components';

import { colorSecondary900 } from 'src/styles/colors';
import { fontPrimary, fonts } from 'src/styles/fonts';

export const GlobalStyle = createGlobalStyle`
  ${fonts};

  body {
    margin: 0;
    font-family: ${fontPrimary};
    color: ${colorSecondary900};
    height: 100%;
  }

  /* stylelint-disable selector-max-id, declaration-no-important */
  html,
  #root {
    height: 100%;
  }
  /* stylelint-enable selector-max-id, declaration-no-important */
`;
